<template>
    <section class="">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     :btn_edit="false"
                     :btn_add="false"
                     :btn_delete="false"
                     btn_review
                     @review="handleMeetingReview"
        >
        </front-table>
        <!--编辑界面-->

        <el-dialog :title="(meeting.id?'('+meeting.id+')':'')+meeting.topic " :visible.sync="view_mode"
                   v-mobile-dialog
                   append-to-body
                   :close-on-click-modal="false" >

            <el-row :gutter="20">
                <el-col :span="24">
                    <div class="d-flex">
                        <div class="page-label">会议id:</div>
                        <div class="page-content">{{meeting.meeting_id?meeting.meeting_id:'待创建'}}</div>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="d-flex">
                        <div class="page-label">会议时间:</div>
                        <div class="page-content">{{meeting.meeting_date}} {{meeting.meeting_time}} ({{meeting.duration}})
                        </div>
                    </div>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="24">
                    <div class="d-flex">
                        <div class="page-label">参会链接:</div>
                        <div class="page-content">{{meeting.join_url}}</div>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="d-flex">
                        <div class="page-label">密码:</div>
                        <div class="page-content"><b>{{meeting.password?meeting.password:'无'}}</b> <span v-if="meeting.zcode"
                                                                                                       class="text-danger"> | 主持密码:{{meeting.zcode}}</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <div class="d-flex">
                        <div class="page-label">主持人:</div>
                        <div class="page-content">{{meeting.host_id}}({{meeting.host_name}}) <span class="text-success" v-if="meeting.assistant_name"> | {{meeting.assistant_name}}</span> </div>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="d-flex">
                        <div class="page-label">会议室:</div>
                        <div class="page-content">{{meeting.room_name_group}}</div>
                    </div>
                </el-col>
                <el-col :span="24" >
                    <el-table
                        class="bg-light"
                        size="mini"
                        :data="single.participants?single.participants.filter(data => !search_user || data.name.toLowerCase().includes(search_user.toLowerCase())):[]"
                        stripe
                        style="width: 100%">
                        <el-table-column prop="name" >
                            <div slot="header" class="d-flex" slot-scope="scope">
                                <el-input style="flex:1 1 5em" v-model="search_user" size="mini" v-if="scope" clearable
                                          placeholder="搜索用户"/>
                            </div>
                            <template slot-scope="scope">
                                <span :class="{'text-danger':(scope.row.user_role === 6)}">{{scope.row.name}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="user_role" label="级" width="40"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.user_role < 2" @click="coHost(scope.row)" type="text" size="small" icon="el-icon-arrow-right">设为联席主持人</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <div class="pull-left">
                <el-button type="danger" size="small" @click="handleLock" > 关闭会议 </el-button>
                    <el-button type="success" size="small" @click="handleUnlock"> 开启会议 </el-button>
                </div>
                <el-button type="info" @click="view_mode=false">关 闭</el-button>
            </div>
        </el-dialog>

        <div class="clearfix"></div>
    </section>
</template>

<script>
    import FrontTable from "@/components/front-mobile-table";
    import FrontMixins from "@/common/mixins/front-mixins";
    import AdminLockMixins from "@/views/mixins/admin-lock-mixins";

    export default {
        mixins: [FrontMixins,AdminLockMixins],
        name: 'meeting-lock',
        components: {FrontTable},
    }
</script>

<style lang="scss">
.page-label {
    flex: 0 0 80px;
    width: 80px;
    text-align: left;
    font-weight: bold;
    display: inline-block;
    line-height: 30px;
    background-color: aliceblue;
    padding: 0 5px;
}

.page-content {
    flex: 1;
    text-align: left;
    margin-left: 10px;
    display: inline-block;
    line-height: 30px;
    border-bottom: solid 1px #b2ebf2;
    overflow: auto;
}

</style>
